<template>
  <div class="container-fluid mt-0 home-page">
    
    <!-- 顶部标题与分享 -->
    <header class="home-overview-head">
      <div class="d-flex align-items-baseline flex-wrap">
        <h1 class="mr-2">市场概览</h1>
        <p class="mb-0 text-muted">先看今日题材，再结合盘中情绪与主要指数确认市场状态</p>
      </div>
      <WxShare />
    </header>
    
    <!-- 1. 今日强势题材雷达 TOP3 -->
    <section class="home-section topics-section">
      <HomeTopicHighlights />
    </section>

    <!-- 2. 市场情绪周期（日内分时演进 + 按天中短期周期） -->
    <section class="home-section sentiment-section">
      <header class="home-section-head">
        <div>
          <h2>市场情绪</h2>
          <span>盘中分时热度演进 与 中短期情绪周期</span>
        </div>
        <router-link to="/sentiment/cyclicality" class="detail-link">详细周期分析 <span>→</span></router-link>
      </header>

      <div class="row chart-grid">
        <!-- Hot Trend Chart (日内情绪/涨跌分布/涨跌数) -->
        <div class="col-12 col-lg-6 mb-3">
          <div class="card shadow-sm h-100 chart-card">
            <div class="card-body p-0">
              <component :is="sentimentHotTrend" v-if="showTrend" zoom_start="0" :compact="true"></component>
              <div v-else class="text-center py-5">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
                <p class="mt-2 text-muted">加载日内情绪中...</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Hot Day Chart (按天历史情绪周期与极值警戒) -->
        <div class="col-12 col-lg-6 mb-3">
          <div class="card shadow-sm h-100 chart-card">
            <div class="card-body p-2">
              <component :is="sentimentHotDay" v-if="showDay" zoom_start="45" :compact="true"></component>
              <div v-else class="text-center py-5">
                 <b-spinner variant="primary" label="Loading..."></b-spinner>
                 <p class="mt-2 text-muted">加载按天周期中...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 3. 核心大盘指数（位于情绪图表下方） -->
    <section class="home-section index-section">
      <header class="home-section-head">
        <div>
          <h2>主要指数</h2>
          <span>当日走势与最新涨跌幅</span>
        </div>
      </header>
      <div class="row">
        <div class="col-12">
          <SentimentIndexMiniCards />
        </div>
      </div>
    </section>

    <!-- 4. 每日关注摘要 -->
    <section class="home-section followed-section">
      <HomeFollowedTopics />
    </section>
  </div>
</template>

<script>
import WxShare from '@/components/share/WxShare.vue'
import HomeTopicHighlights from '@/components/home/HomeTopicHighlights.vue'
import HomeFollowedTopics from '@/components/home/HomeFollowedTopics.vue'
import SentimentIndexMiniCards from '@/components/sentiment/SentimentIndexMiniCards.vue'

export default {
  name: 'Home',
  components: {
    WxShare,
    HomeTopicHighlights,
    HomeFollowedTopics,
    SentimentIndexMiniCards
  },
  data() {
    return {
      sentimentHotTrend: null,
      sentimentHotDay: null,
      showTrend: false,
      showDay: false
    }
  },
  methods: {
    loadTrend() {
      import('components/sentiment/SentimentMarketHotTrend.vue').then(module => {
        this.sentimentHotTrend = module.default;
        this.showTrend = true;
      }).catch(err => {
        console.error("Failed to load trend chart:", err);
      });
    },
    loadDay() {
      import('components/sentiment/SentimentMarketHotDay.vue').then(module => {
        this.sentimentHotDay = module.default;
        this.showDay = true;
      }).catch(err => {
         console.error("Failed to load day chart:", err);
      });
    }
  },
  mounted() {
    this.loadTrend();
    this.loadDay();
  }
}
</script>

<style scoped>
.home-page {
  --home-ink: #1e293b;
  --home-muted: #64748b;
  --home-border: #e2e8f0;
  --home-card-bg: #ffffff;
  padding-top: 0;
  padding-bottom: 30px;
}
.home-overview-head {
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--home-border);
  margin-bottom: 12px;
}
.home-overview-head h1 {
  display: inline;
  margin: 0;
  color: var(--home-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.home-overview-head p {
  display: inline;
  margin: 0 0 0 10px;
  color: var(--home-muted);
  font-size: 12px;
}
.home-section {
  margin-bottom: 14px;
}
.home-section-head {
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.home-section-head > div {
  display: flex;
  align-items: baseline;
  gap: 9px;
}
.home-section-head h2 {
  margin: 0;
  color: var(--home-ink);
  font-size: 16px;
  font-weight: 700;
}
.home-section-head span {
  color: var(--home-muted);
  font-size: 11px;
}
.detail-link {
  font-size: 11px;
  font-weight: 600;
  color: #0284c7;
  text-decoration: none;
  transition: color 0.15s ease;
}
.detail-link:hover {
  color: #0369a1;
  text-decoration: underline;
}
.chart-grid {
  margin-top: 0;
}
.chart-card {
  background-color: var(--home-card-bg);
  border: 1px solid var(--home-border);
  border-radius: 9px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02) !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.chart-card:hover {
  border-color: rgba(2, 132, 199, 0.35);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
}
.card-body ::v-deep .echarts {
  width: 100% !important;
}

@media(max-width: 650px) {
  .home-page { padding-left: 8px; padding-right: 8px; }
  .home-overview-head { min-height: 42px; }
  .home-overview-head h1 { font-size: 17px; }
  .home-overview-head p { display: none; }
  .home-section-head > div { display: block; }
  .home-section-head h2 { font-size: 15px; }
}
</style>

<style>
.theme-dark .home-page {
  --home-ink: #f1f5f9;
  --home-muted: #94a3b8;
  --home-border: #334155;
  --home-card-bg: #1e293b;
}
.theme-dark .detail-link {
  color: #38bdf8;
}
.theme-dark .detail-link:hover {
  color: #7dd3fc;
}
</style>
